/* eslint-disable @typescript-eslint/no-explicit-any */

import httpRequest from "@/auth/http-client";
import { getMimeType } from "@/helpers/file-helpers";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import { IMedia, IMediaInput } from "@/interfaces/media.interface";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class MediaService {
  private baseUrl = "api/v1/midia";

  async getAll(pagination: RequestPagination): Promise<PaginatedResponse<IMedia>> {
    const paginationQuery = buildPaginationQuery(pagination);
    const media = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return media;
  }

  async filter(
    filter: IFilter<IMedia>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<IMedia>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async create(formData: IMediaInput): Promise<void> {
    await httpRequest.post(this.baseUrl, formData);
  }

  async getById(mediaId: number | string): Promise<IMedia> {
    const media = await httpRequest.get(`${this.baseUrl}/${mediaId}`);
    return media;
  }

  async download(mediaId: number | string, media: IMedia): Promise<string> {
    const response = await httpRequest.get(`${this.baseUrl}/${mediaId}/download`, {
      responseType: "arraybuffer",
    });

    if (!response) {
      throw new Error("Failed to download media.");
    }

    const base64 = btoa(
      new Uint8Array(response).reduce((data, byte) => data + String.fromCharCode(byte), "")
    );

    const mimeType = getMimeType(media);
    return `data:${mimeType};base64,${base64}`;
  }

  async update(formData: IMediaInput, mediaId: number): Promise<void> {
    await httpRequest.put(`${this.baseUrl}/${mediaId}`, formData);
  }

  async delete(mediaId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${mediaId}`);
  }
}

const mediaService = new MediaService();
export default mediaService;
